import { Component, input, output, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ContactData, ContactSelectorModalComponent } from '../contact-selector-modal/contact-selector-modal.component';

export interface SelectedPreviewContext {
  accountGroupId: string;
  name: string;
  hasSalesperson: boolean;
  hasSnapshot: boolean;
  contactID?: string;
  useFakeData?: boolean;
}

@Component({
  selector: 'email-preview-selector',
  templateUrl: './preview-context-selector.component.html',
  styleUrls: ['./preview-context-selector.component.scss'],
  standalone: false,
})
export class PreviewContextSelectorComponent {
  contextSelected = output<SelectedPreviewContext>();
  protected readonly selectedName = signal('');
  namespace = input.required<string>();

  constructor(private readonly dialog: MatDialog) {}

  async openSelectDialog(): Promise<void> {
    const dialog = this.dialog.open(ContactSelectorModalComponent, {
      data: { namespace: this.namespace() },
      minWidth: '350px',
    });
    const contact: ContactData = await firstValueFrom(dialog.afterClosed());
    if (contact) {
      const sel: SelectedPreviewContext = {
        accountGroupId: contact.namespace,
        name: contact.name,
        hasSnapshot: false,
        hasSalesperson: false,
        contactID: contact.contactID,
        useFakeData: false,
      };
      this.selectedName.set(contact.name);
      this.contextSelected.emit(sel);
    }
  }
}
